<section class="">
    <div class="container-12 p-0">
        @if (order) {
            @if (order.shipping.kind === 'delivery') {
                <update-order-delivery-address [order]="order"></update-order-delivery-address>
            } @else {
                <p>
                    {{ 'dev.myAccount.orders.updateShipping.shippingMethodNotEditable' | translate }}
                </p>
            }
        } @else {
            <p>
                {{ 'dev.myAccount.orders.updateShipping.orderNotFound' | translate }}
            </p>
        }
    </div>
</section>
